module.exports = __webpack_public_path__ + "static/media/06.c55637b4.png";